import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { config, TermsAndCondtionsType, AddressType, PurchaseService, MemberQuery, AddressQuery, ErrorStateService, BalanceService, TransactionSuccessService, MarketplaceQuery, MarketplaceService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { tap, take, takeUntil } from 'rxjs/operators';
import { Validators, FormBuilder } from '@angular/forms';
import { RegexUS } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { CollectAddressModal } from '@fgb/portal-component-library/src/lib/loyalty/collect-address-modal';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@fgb/core';
import * as ɵngcc3 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc4 from '@angular/router';
import * as ɵngcc5 from '@angular/common';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc7 from '@ngx-translate/core';
import * as ɵngcc8 from '@fgb/portal-component-library/src/lib/pipes';

function MarketplacePurchaseConfirmationComponent_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "marketplace.confirm.message"));
} }
function MarketplacePurchaseConfirmationComponent_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "events.confirm.message"));
} }
function MarketplacePurchaseConfirmationComponent_div_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "products.confirm.message"));
} }
function MarketplacePurchaseConfirmationComponent_div_2_ng_container_14_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "span", 23);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attribute_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(attribute_r8.AttributeName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", attribute_r8.ValueName, "");
} }
function MarketplacePurchaseConfirmationComponent_div_2_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 20);
    ɵngcc0.ɵɵtemplate(2, MarketplacePurchaseConfirmationComponent_div_2_ng_container_14_div_2_Template, 5, 2, "div", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.selectedAttributes);
} }
function MarketplacePurchaseConfirmationComponent_div_2_ng_container_15_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵelementStart(1, "span", 28);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r10 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", field_r10.customFieldName, ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", field_r10.customFieldValue, "");
} }
function MarketplacePurchaseConfirmationComponent_div_2_ng_container_15_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtemplate(1, MarketplacePurchaseConfirmationComponent_div_2_ng_container_15_div_1_div_1_Template, 5, 2, "div", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r10 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r10.customFieldValue);
} }
function MarketplacePurchaseConfirmationComponent_div_2_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MarketplacePurchaseConfirmationComponent_div_2_ng_container_15_div_1_Template, 2, 1, "div", 24);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.validCustomFields);
} }
function MarketplacePurchaseConfirmationComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p", 6);
    ɵngcc0.ɵɵtemplate(2, MarketplacePurchaseConfirmationComponent_div_2_ng_container_2_Template, 3, 3, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(3, MarketplacePurchaseConfirmationComponent_div_2_ng_container_3_Template, 3, 3, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(4, MarketplacePurchaseConfirmationComponent_div_2_ng_container_4_Template, 3, 3, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "hr", 7);
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵelementStart(7, "div", 9);
    ɵngcc0.ɵɵelement(8, "img", 10);
    ɵngcc0.ɵɵpipe(9, "contentImage");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 11);
    ɵngcc0.ɵɵelementStart(11, "div", 12);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 13);
    ɵngcc0.ɵɵtemplate(14, MarketplacePurchaseConfirmationComponent_div_2_ng_container_14_Template, 3, 1, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(15, MarketplacePurchaseConfirmationComponent_div_2_ng_container_15_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementStart(16, "div", 14);
    ɵngcc0.ɵɵelementStart(17, "div", 15);
    ɵngcc0.ɵɵelementStart(18, "span", 16);
    ɵngcc0.ɵɵtext(19);
    ɵngcc0.ɵɵpipe(20, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "span");
    ɵngcc0.ɵɵtext(22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 17);
    ɵngcc0.ɵɵelementStart(24, "div", 18);
    ɵngcc0.ɵɵelementStart(25, "span", 19);
    ɵngcc0.ɵɵtext(26);
    ɵngcc0.ɵɵpipe(27, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "span");
    ɵngcc0.ɵɵtext(29);
    ɵngcc0.ɵɵpipe(30, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.marketplaceItemType == "Marketplace");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.marketplaceItemType == "Event");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.marketplaceItemType == "Product");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind3(9, 14, ctx_r0.marketplaceItem.ItemImageURL, "7", "marketplace"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵpropertyInterpolate("alt", ctx_r0.marketplaceItem.ItemImageURL);
    ɵngcc0.ɵɵproperty("useDefault", true)("loyaltyType", "marketplace");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.marketplaceItem.DisplayName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.attributeMappingID && ctx_r0.selectedAttributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.validCustomFields);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(20, 18, "marketplace.quantity"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.purchaseQuantity, "");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(27, 20, "marketplace.points.value"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(30, 22, ctx_r0.marketplaceItem.PointValue * ctx_r0.purchaseQuantity), "");
} }
function MarketplacePurchaseConfirmationComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 13);
    ɵngcc0.ɵɵelementStart(6, "div", 29);
    ɵngcc0.ɵɵelementStart(7, "label");
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(10, "span", 30);
    ɵngcc0.ɵɵelementStart(11, "span", 31);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 29);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(17, "span", 32);
    ɵngcc0.ɵɵelementStart(18, "span", 33);
    ɵngcc0.ɵɵtext(19);
    ɵngcc0.ɵɵpipe(20, "FortressCurrencyPipe");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 5, "marketplace.card.confirm.message"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 7, "marketplace.quantity"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.purchaseQuantity);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(16, 9, "marketplace.card.merchant.price"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(20, 11, ctx_r1.marketplaceItem.MerchantValue / 100 * ctx_r1.purchaseQuantity));
} }
class MarketplacePurchaseConfirmationComponent {
    constructor(formBuilder, purchaseService, memberQuery, addressQuery, modalService, router, errorService, balanceService, transactionSuccessService, marketplaceQuery, marketplaceService) {
        this.formBuilder = formBuilder;
        this.purchaseService = purchaseService;
        this.memberQuery = memberQuery;
        this.addressQuery = addressQuery;
        this.modalService = modalService;
        this.router = router;
        this.errorService = errorService;
        this.balanceService = balanceService;
        this.transactionSuccessService = transactionSuccessService;
        this.marketplaceQuery = marketplaceQuery;
        this.marketplaceService = marketplaceService;
        this.config = config;
        this.TermsAndCondtionsType = TermsAndCondtionsType;
        this.purchaseLoading = new EventEmitter();
        this.addToCartTermsConfirmed = new EventEmitter();
        this._destroyed$ = new Subject();
    }
    ngOnInit() {
        this.memberQuery
            .selectMemberDetails()
            .pipe(tap((z) => {
            if (z) {
                this.defaultAddress = {
                    FirstName: z.FirstName,
                    Surname: z.Surname,
                    Street: z.Street,
                    Town: z.Town,
                    County: z.County,
                    Postcode: z.PostCode,
                    Country: z.Country,
                    HomeNumber: z.HomeNumber,
                    EmailAddress: z.EmailAddress1,
                    PortalId: z.PortalId,
                    ClubId: z.ClubId,
                    AddressName: 'Default Address',
                    AddressType: AddressType.DefaultAddress,
                };
            }
        }))
            .toPromise();
        this.addressQuery
            .selectAddresses([AddressType.DefaultAddress])
            .pipe(take(1), tap((addresses) => {
            this.addresses = addresses;
            this.memberQuery
                .selectMemberDetails()
                .pipe(take(1), tap((md) => {
                if (md) {
                    this.member = md;
                    this.shippingAddress = this._getDefaultShippingAddress();
                    this.shippingAddressForm = this.formBuilder.group({
                        addressName: [this.shippingAddress.AddressName, Validators.required],
                        emailAddress: [this.shippingAddress.EmailAddress, Validators.email],
                        street: [this.shippingAddress.Street, Validators.required],
                        town: [this.shippingAddress.Town, Validators.required],
                        county: [this.shippingAddress.County, Validators.required],
                        country: [this.shippingAddress.Country, Validators.required],
                        postcode: [this.shippingAddress.Postcode, [Validators.required, Validators.pattern(RegexUS.postCode)]],
                        firstName: [this.shippingAddress.FirstName, Validators.required],
                        surname: [this.shippingAddress.Surname, Validators.required],
                        homeNumber: [this.shippingAddress.HomeNumber, Validators.required],
                        portalId: [this.member.PortalId],
                        clubId: [this.member.ClubId],
                    });
                }
            }))
                .subscribe();
        }))
            .subscribe();
    }
    _getDefaultShippingAddress() {
        if (this.addresses) {
            let shippingAddress1 = this.addresses.filter((a) => a.AddressType === AddressType.ShippingAddress1)[0];
            if (shippingAddress1) {
                return shippingAddress1;
            }
            let shippingAddress2 = this.addresses.filter((a) => a.AddressType === AddressType.ShippingAddress2)[0];
            if (shippingAddress2) {
                return shippingAddress2;
            }
        }
        return {
            FirstName: '',
            Surname: '',
            Street: '',
            Town: '',
            County: '',
            Postcode: '',
            Country: '',
            HomeNumber: '',
            EmailAddress: '',
            PortalId: this.member.PortalId,
            ClubId: this.member.ClubId,
            AddressType: AddressType.ShippingAddress1,
            AddressName: 'Shipping Address',
        };
    }
    openAddressCollectionModal(address, orderId, saveMemberDetailsAddress, saveShippingAddress, saveOrderAddress) {
        const modal = this.modalService.open(CollectAddressModal, { ariaLabelledBy: 'modal-basic-title', centered: true });
        modal.componentInstance.address = address;
        modal.componentInstance.orderId = orderId;
        modal.componentInstance.saveMemberDetailsAddress = saveMemberDetailsAddress;
        modal.componentInstance.saveShippingAddress = saveShippingAddress;
        modal.componentInstance.saveOrderAddress = saveOrderAddress;
        modal.componentInstance.submittedAddress.pipe(takeUntil(this._destroyed$)).subscribe(() => {
            this.closeModal();
            this.continueOrder(orderId);
        });
    }
    openTerms(content) {
        this.modalService.open(content, { centered: true });
    }
    purchase() {
        if (this.addToCart) {
            this.modalService.dismissAll();
            this.addToCartTermsConfirmed.emit(true);
        }
        else {
            this.purchaseLoading.emit(true);
            let price = this.marketplaceQuery.getPrice(this.marketplaceItem.Id);
            if (price == undefined)
                return;
            let cost = price * this.purchaseQuantity;
            this.marketplaceService
                .purchaseItemWithProviderResopnse(this.marketplaceItem.Id, this.purchaseQuantity, this.attributeMappingID, undefined, this.validCustomFields ? this.validCustomFields : [], this.templateSelected === 'confirmContentCardPayment' ? true : false)
                .then((response) => {
                if (response && response.Success) {
                    this.balanceService.debitBalance(this.config.purseConfig.virtualLoyalty, cost);
                    let item = this.marketplaceQuery.getEntity(this.marketplaceItem.Id);
                    if (item) {
                        this.transactionSuccessService.setTransaction(item, this.purchaseQuantity, cost, response.OrderId);
                    }
                    this.router.navigate(['rewards/marketplace/purchase/success/']);
                }
                else if (response) {
                    if (response.ProviderActionInformation.NextAction) {
                        if (response.ProviderActionInformation.NextAction == 20) {
                            this.openAddressCollectionModal(this.shippingAddress, response.OrderId, false, true, false);
                        }
                        else if (response.ProviderActionInformation.NextAction == 40) {
                            this.openAddressCollectionModal(this.defaultAddress, response.OrderId, true, false, false);
                        }
                    }
                    else {
                        this.errorService.clearErrors();
                        this.errorService.addError(!!response.ErrorMessage ? response.ErrorMessage : 'Purchase failed');
                    }
                }
            })
                .catch((e) => {
                this.errorService.clearErrors();
                this.errorService.addError(e.error && !!e.error.Message ? e.error.Message : e.message);
            })
                .finally(() => {
                this.purchaseLoading.emit(false);
            });
        }
    }
    continueOrder(orderId) {
        let price = this.marketplaceQuery.getPrice(this.marketplaceItem.Id);
        if (price == undefined)
            return;
        let cost = price * this.purchaseQuantity;
        this.purchaseLoading.emit(true);
        this.purchaseService
            .continueOrder(orderId)
            .toPromise()
            .then((continueResponse) => {
            if (continueResponse.Data.Success) {
                this.balanceService.debitBalance(this.config.purseConfig.virtualLoyalty, cost);
                let item = this.marketplaceQuery.getEntity(this.marketplaceItem.Id);
                if (item) {
                    this.transactionSuccessService.setTransaction(item, this.purchaseQuantity, cost);
                }
                this.router.navigate(['rewards/marketplace/purchase/success/']);
            }
            else {
                this.errorService.clearErrors();
                this.errorService.addError(!!continueResponse.ErrorMessage ? continueResponse.ErrorMessage : 'Purchase failed');
            }
            this.purchaseLoading.emit(false);
        });
    }
    closeModal() {
        this.modalService.dismissAll();
    }
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}
MarketplacePurchaseConfirmationComponent.ɵfac = function MarketplacePurchaseConfirmationComponent_Factory(t) { return new (t || MarketplacePurchaseConfirmationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.PurchaseService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MemberQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.AddressQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ErrorStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.BalanceService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.TransactionSuccessService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MarketplaceQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MarketplaceService)); };
MarketplacePurchaseConfirmationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MarketplacePurchaseConfirmationComponent, selectors: [["fgbcl-marketplace-purchase-confirmation"]], inputs: { templateSelected: "templateSelected", marketplaceItem: "marketplaceItem", marketplaceItemType: "marketplaceItemType", attributeMappingID: "attributeMappingID", selectedAttributes: "selectedAttributes", validCustomFields: "validCustomFields", purchaseQuantity: "purchaseQuantity", addToCart: "addToCart" }, outputs: { purchaseLoading: "purchaseLoading", addToCartTermsConfirmed: "addToCartTermsConfirmed" }, decls: 11, vars: 8, consts: [[1, "d-flex", "flex-column", "justify-content-between", "flex-grow-1", "flex-shrink-1"], [1, "modal-body"], [4, "ngIf"], [1, "modal-footer", "d-flex", "justify-content-between", "border-0"], ["id", "cancel-button", "type", "button", 1, "btn", "btn-purchase-cancel", 3, "click"], ["id", "confirm-button", "type", "button", 1, "btn", "btn-purchase-confirm", 3, "click"], [1, "purchase-confirmation-title"], [1, "mt-0", "mx-5"], [1, "row", "my-5"], [1, "col-lg-2", "col-3", "d-flex", "justify-content-center"], ["draggable", "false", 1, "confirm-modal-image", "shadow", "rounded", 3, "src", "alt", "useDefault", "loyaltyType"], [1, "col-lg-10", "col-9", "pl-0"], [1, "purchase-confirmation-name", "mb-1"], [1, "row"], [1, "col-4", "col-lg-3", "mt-2"], [1, "quanity-value", "font-size-12", "mb-0"], [1, "quantity-title", "font-weight-bold"], [1, "col-6", "col-lg-5", "mt-2"], ["id", "points-value", 1, "point-value", "mb-0"], [1, "point-title"], [1, "col-12", "mt-1"], ["class", "confirmation-attribute-values mb-0 attribute", 4, "ngFor", "ngForOf"], [1, "confirmation-attribute-values", "mb-0", "attribute"], [1, "confirmation-attribute-name"], ["class", "col-12", 4, "ngFor", "ngForOf"], [1, "col-12"], ["class", "confirmation-custom-field-values mb-0 field", 4, "ngIf"], [1, "confirmation-custom-field-values", "mb-0", "field"], [1, "confirmation-custom-field-name"], [1, "col-6", "my-3"], [1, "icon", "icon-basket", "mr-1"], [1, "text-primary"], [1, "icon", "icon-trophy-1", "mr-1"], ["id", "merchant-price", 1, "text-primary"]], template: function MarketplacePurchaseConfirmationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, MarketplacePurchaseConfirmationComponent_div_2_Template, 31, 24, "div", 2);
        ɵngcc0.ɵɵtemplate(3, MarketplacePurchaseConfirmationComponent_div_3_Template, 21, 13, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "button", 4);
        ɵngcc0.ɵɵlistener("click", function MarketplacePurchaseConfirmationComponent_Template_button_click_5_listener() { return ctx.purchaseLoading.emit(false); });
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "button", 5);
        ɵngcc0.ɵɵlistener("click", function MarketplacePurchaseConfirmationComponent_Template_button_click_8_listener() { return ctx.purchase(); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.templateSelected === "confirmContent");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.templateSelected === "confirmContentCardPayment");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(7, 4, "modal.cancel"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 6, "modal.confirm"), " ");
    } }, directives: [ɵngcc5.NgIf, ɵngcc6.ImgDefaultDirective, ɵngcc5.NgForOf], pipes: [ɵngcc7.TranslatePipe, ɵngcc8.ContentImagePipe, ɵngcc5.DecimalPipe, ɵngcc8.FortressCurrencyPipe], styles: [".modal-image[_ngcontent-%COMP%]{width:390px;height:390px}@media (max-width:991px){.modal-image[_ngcontent-%COMP%]{width:100%;height:340px}}.modal-body[_ngcontent-%COMP%]{font-size:14px;padding:1rem 1.5rem}.modal-footer[_ngcontent-%COMP%]{font-size:14px;padding:.75rem 1.25rem}.modal-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-width:142px;width:100%;font-size:.875rem}.terms[_ngcontent-%COMP%]{position:relative;display:inline-block}.terms[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{position:absolute;left:0;top:0;min-width:1em;width:100%;height:100%;z-index:2;opacity:0;margin:0;padding:0;cursor:pointer}.terms[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{text-indent:30px;font-size:.825rem;margin:0}.terms[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:after, .terms[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:before{content:\"\";width:20px;height:20px;border:1px solid transparent;position:absolute;left:0;transform:translateY(-50%);top:50%;background-color:transparent;border-radius:20%}.terms[_ngcontent-%COMP%]   .state[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:before{border-color:#000}.terms[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .state[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:after{background-color:#000!important;transform:translateY(-50%) scale(.8)}.links[_ngcontent-%COMP%]{display:inline}"] });
MarketplacePurchaseConfirmationComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: PurchaseService },
    { type: MemberQuery },
    { type: AddressQuery },
    { type: NgbModal },
    { type: Router },
    { type: ErrorStateService },
    { type: BalanceService },
    { type: TransactionSuccessService },
    { type: MarketplaceQuery },
    { type: MarketplaceService }
];
MarketplacePurchaseConfirmationComponent.propDecorators = {
    templateSelected: [{ type: Input }],
    marketplaceItem: [{ type: Input }],
    marketplaceItemType: [{ type: Input }],
    attributeMappingID: [{ type: Input }],
    selectedAttributes: [{ type: Input }],
    validCustomFields: [{ type: Input }],
    purchaseQuantity: [{ type: Input }],
    addToCart: [{ type: Input }],
    purchaseLoading: [{ type: Output }],
    addToCartTermsConfirmed: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplacePurchaseConfirmationComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-marketplace-purchase-confirmation',
                template: "<div class=\"d-flex flex-column justify-content-between flex-grow-1 flex-shrink-1\">\r\n  <div class=\"modal-body\">\r\n    <div *ngIf=\"templateSelected === 'confirmContent'\">\r\n      <p class=\"purchase-confirmation-title\">\r\n        <ng-container *ngIf=\"marketplaceItemType == 'Marketplace'\">{{ 'marketplace.confirm.message' | translate }}</ng-container>\r\n        <ng-container *ngIf=\"marketplaceItemType == 'Event'\">{{ 'events.confirm.message' | translate }}</ng-container>\r\n        <ng-container *ngIf=\"marketplaceItemType == 'Product'\">{{ 'products.confirm.message' | translate }}</ng-container>\r\n      </p>\r\n      <hr class=\"mt-0 mx-5\" />\r\n      <div class=\"row my-5\">\r\n        <div class=\"col-lg-2 col-3 d-flex justify-content-center\">\r\n          <img\r\n            class=\"confirm-modal-image shadow rounded\"\r\n            src=\"{{ marketplaceItem.ItemImageURL | contentImage: '7':'marketplace' }}\"\r\n            alt=\"{{ marketplaceItem.ItemImageURL }}\"\r\n            [useDefault]=\"true\"\r\n            [loyaltyType]=\"'marketplace'\"\r\n            draggable=\"false\"\r\n          />\r\n        </div>\r\n        <div class=\"col-lg-10 col-9 pl-0\">\r\n          <div class=\"purchase-confirmation-name mb-1\">{{ marketplaceItem.DisplayName }}</div>\r\n          <div class=\"row\">\r\n            <ng-container *ngIf=\"attributeMappingID && selectedAttributes\">\r\n              <div class=\"col-12 mt-1\">\r\n                <div *ngFor=\"let attribute of selectedAttributes\" class=\"confirmation-attribute-values mb-0 attribute\">\r\n                  <span class=\"confirmation-attribute-name\">{{ attribute.AttributeName }}</span>\r\n                  <span> {{ attribute.ValueName }}</span>\r\n                </div>\r\n              </div>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"validCustomFields\">\r\n              <div class=\"col-12\" *ngFor=\"let field of validCustomFields\">\r\n                <div *ngIf=\"field.customFieldValue\" class=\"confirmation-custom-field-values mb-0 field\">\r\n                  <span class=\"confirmation-custom-field-name\">{{ field.customFieldName }}:</span>\r\n                  <span> {{ field.customFieldValue }}</span>\r\n                </div>\r\n              </div>\r\n            </ng-container>\r\n            <div class=\"col-4 col-lg-3 mt-2\">\r\n              <div class=\"quanity-value font-size-12 mb-0\">\r\n                <span class=\"quantity-title font-weight-bold\">{{ 'marketplace.quantity' | translate }}</span>\r\n                <span> {{ purchaseQuantity }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-6 col-lg-5 mt-2\">\r\n              <div id=\"points-value\" class=\"point-value mb-0\">\r\n                <span class=\"point-title\">{{ 'marketplace.points.value' | translate }}</span>\r\n                <span> {{ marketplaceItem.PointValue * purchaseQuantity | number }}</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"templateSelected === 'confirmContentCardPayment'\">\r\n      <p>\r\n        <b>{{ 'marketplace.card.confirm.message' | translate }}</b>\r\n      </p>\r\n      <div class=\"row\">\r\n        <div class=\"col-6 my-3\">\r\n          <label>{{ 'marketplace.quantity' | translate }}</label>\r\n          <span class=\"icon icon-basket mr-1\"></span>\r\n          <span class=\"text-primary\">{{ purchaseQuantity }}</span>\r\n        </div>\r\n        <div class=\"col-6 my-3\">\r\n          <label>{{ 'marketplace.card.merchant.price' | translate }}</label>\r\n          <span class=\"icon icon-trophy-1 mr-1\"></span>\r\n          <span id=\"merchant-price\" class=\"text-primary\">{{\r\n            (marketplaceItem.MerchantValue / 100) * purchaseQuantity | FortressCurrencyPipe\r\n          }}</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"modal-footer d-flex justify-content-between border-0\">\r\n    <button id=\"cancel-button\" type=\"button\" class=\"btn btn-purchase-cancel\" (click)=\"purchaseLoading.emit(false)\">\r\n      {{ 'modal.cancel' | translate }}\r\n    </button>\r\n    <button id=\"confirm-button\" type=\"button\" class=\"btn btn-purchase-confirm\" (click)=\"purchase()\">\r\n      {{ 'modal.confirm' | translate }}\r\n    </button>\r\n  </div>\r\n</div>\r\n",
                styles: [".modal-image{width:390px;height:390px}@media (max-width:991px){.modal-image{width:100%;height:340px}}.modal-body{font-size:14px;padding:1rem 1.5rem}.modal-footer{font-size:14px;padding:.75rem 1.25rem}.modal-footer button{max-width:142px;width:100%;font-size:.875rem}.terms{position:relative;display:inline-block}.terms input{position:absolute;left:0;top:0;min-width:1em;width:100%;height:100%;z-index:2;opacity:0;margin:0;padding:0;cursor:pointer}.terms label{text-indent:30px;font-size:.825rem;margin:0}.terms .state label:after,.terms .state label:before{content:\"\";width:20px;height:20px;border:1px solid transparent;position:absolute;left:0;transform:translateY(-50%);top:50%;background-color:transparent;border-radius:20%}.terms .state label:before{border-color:#000}.terms input:checked~.state label:after{background-color:#000!important;transform:translateY(-50%) scale(.8)}.links{display:inline}"]
            }]
    }], function () { return [{ type: ɵngcc1.FormBuilder }, { type: ɵngcc2.PurchaseService }, { type: ɵngcc2.MemberQuery }, { type: ɵngcc2.AddressQuery }, { type: ɵngcc3.NgbModal }, { type: ɵngcc4.Router }, { type: ɵngcc2.ErrorStateService }, { type: ɵngcc2.BalanceService }, { type: ɵngcc2.TransactionSuccessService }, { type: ɵngcc2.MarketplaceQuery }, { type: ɵngcc2.MarketplaceService }]; }, { purchaseLoading: [{
            type: Output
        }], addToCartTermsConfirmed: [{
            type: Output
        }], templateSelected: [{
            type: Input
        }], marketplaceItem: [{
            type: Input
        }], marketplaceItemType: [{
            type: Input
        }], attributeMappingID: [{
            type: Input
        }], selectedAttributes: [{
            type: Input
        }], validCustomFields: [{
            type: Input
        }], purchaseQuantity: [{
            type: Input
        }], addToCart: [{
            type: Input
        }] }); })();

class MarketplacePurchaseConfirmationModule {
}
MarketplacePurchaseConfirmationModule.ɵfac = function MarketplacePurchaseConfirmationModule_Factory(t) { return new (t || MarketplacePurchaseConfirmationModule)(); };
MarketplacePurchaseConfirmationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MarketplacePurchaseConfirmationModule });
MarketplacePurchaseConfirmationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PipesModule,
            DirectivesModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MarketplacePurchaseConfirmationModule, { declarations: function () { return [MarketplacePurchaseConfirmationComponent]; }, imports: function () { return [CommonModule,
        PipesModule,
        DirectivesModule, ɵngcc7.TranslateModule]; }, exports: function () { return [MarketplacePurchaseConfirmationComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplacePurchaseConfirmationModule, [{
        type: NgModule,
        args: [{
                declarations: [MarketplacePurchaseConfirmationComponent],
                imports: [
                    CommonModule,
                    PipesModule,
                    DirectivesModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [MarketplacePurchaseConfirmationComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MarketplacePurchaseConfirmationComponent, MarketplacePurchaseConfirmationModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-marketplace-marketplace-details-marketplace-purchase-confirmation.js.map